module.exports = __webpack_public_path__ + "img/facebook.418b0033.svg";